import React, { memo } from 'react';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import { useStyles } from './ResizableDrawer.styles';
import { Resizable } from 're-resizable';
import useLocalStorageState from 'use-local-storage-state';

export const DefaultSidebarWidth = 240;
export const LocalStorageStudioSidebarWidthKey = 'veezoo.studio.sidebar.width';
const ResizableDrawer = ({ isResizable, children }) => {
  const [sidebarWidth, setSidebarWidth] = useLocalStorageState(LocalStorageStudioSidebarWidthKey, {
    defaultValue: DefaultSidebarWidth,
    storageSync: false
  });
  const classes = useStyles({ width: isResizable ? sidebarWidth : DefaultSidebarWidth });

  // if the initial sidebar width is bigger than the default sidebar width reset the sidebar width
  if (sidebarWidth > window.innerWidth && sidebarWidth > DefaultSidebarWidth) {
    setSidebarWidth(DefaultSidebarWidth);
  }

  return (
    <Resizable
      defaultSize={{
        width: isResizable ? sidebarWidth : DefaultSidebarWidth,
        height: '100%'
      }}
      maxWidth="100%"
      enable={{ right: isResizable }}
      handleClasses={{ right: classes.handleRight }}
      onResize={(e, direction, ref) => {
        const newWidth = parseInt(ref.style.width, 10);
        setSidebarWidth(newWidth);
      }}
    >
      <Drawer variant="persistent" open className={classes.root} classes={{ paper: classes.paper }}>
        <Toolbar variant="dense" />
        {children}
      </Drawer>
    </Resizable>
  );
};

export default memo(ResizableDrawer);
